import { Component, HostBinding, input, output, Signal, WritableSignal } from '@angular/core';

import { _ImageBoxComponent } from '../abstract-classes/_image-box.component';

@Component({
    selector: 'app_image-box-link',
    template: '',
})
export abstract class _ImageBoxLinkComponent
    extends _ImageBoxComponent
{
    abstract noClick$$: Signal<boolean> | WritableSignal<boolean>;

    abstract emit_onClick(event: any): void;

    input_noClick$$ = input<boolean>(false, {alias: 'noClick'});

    protected _out_onClickEmit = output<void>({alias: 'onClickEmit'});

    @HostBinding('class.noclick') get noClickClass(): boolean {return this.noClick$$()};

    protected _emit_onClick(event: any): void {
        event.stopPropagation();
        this._out_onClickEmit.emit();
    }
}
